import { ApiService } from "@/common/api.service.js";
const backendUrl = process.env.VUE_APP_BACKEND_URL;

export default {
  isAuthenticated() {
    if (
      localStorage.getItem("access") !== null &&
      localStorage.getItem("refresh") !== null
    ) {
      return ApiService.post(
        backendUrl + "/api/token/verify/",
        { token: this.getAccessToken() },
        {},
        false
      );
    } else {
      return false;
    }
  },

  // getters
  getAccessToken() {
    return localStorage.getItem("access");
  },
  getRefreshToken() {
    return localStorage.getItem("refresh");
  },
  getChatToken() {
    return localStorage.getItem("chat");
  },

  // setters
  setAccessToken(access) {
    localStorage.setItem("access", access);
  },
  setRefreshToken(refresh) {
    localStorage.setItem("refresh", refresh);
  },
  setChatToken(chat) {
    localStorage.setItem("chat", chat);
  },

  // logout
  removeTokens() {
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");
    localStorage.removeItem("chat");
  }
};
